import type { ReactElement, ReactNode } from 'react';
import { Icon } from '@/components/atoms/icon';
import { Micro } from '@/components/atoms/micro';
import { cn } from '@/lib/cn';

export type ErrorStateProps = {
  title: string;
  description?: string;
  subtitle?: string;
  action?: ReactNode;
  errorCode?: string;
  className?: string;
};

export function ErrorState({
  title,
  description,
  subtitle,
  action,
  errorCode,
  className,
}: ErrorStateProps): ReactElement {
  return (
    <div className={cn('flex-1 flex flex-col items-center justify-center text-center px-8 py-12', className)}>
      <div
        className="w-14 h-14 rounded-full bg-[var(--err-wash)] text-[var(--err)] flex items-center justify-center mb-5"
        aria-hidden
      >
        <Icon name="x" size={24} strokeWidth={2.5} />
      </div>
      {subtitle && <Micro>{subtitle}</Micro>}
      <h2 className="font-display text-[24px] font-semibold tracking-tight mt-2 leading-tight text-[var(--ink)] max-w-[320px]">
        {title}
      </h2>
      {description && (
        <p className="text-[13px] text-[var(--ink-3)] mt-3 leading-relaxed max-w-[320px]">
          {description}
        </p>
      )}
      {action && <div className="mt-7 flex flex-col gap-2 w-full max-w-xs">{action}</div>}
      {errorCode && (
        <div className="mt-6 font-mono text-[10px] text-[var(--ink-4)]">{errorCode}</div>
      )}
    </div>
  );
}
